module.exports = __webpack_public_path__ + "static/media/book formatting (2).2f026268.png";